export const ROUTES = {
  ROOT: "/",
  REPORTS: (account?: string) => (account ? `/reports/${account}` : "/reports"),
  TRANSACTIONS: (account?: string) =>
    account ? `/transactions/${account}` : "/transactions",
  TRANSACTION_DETAIL: (account: any, transaction?: string) => {
    if (account) {
      if (transaction) {
        return `/transaction/${account}/${transaction || ""}`;
      }
      return `/transaction/${account}`;
    }

    return "/transaction/";
  },
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  SETTINGS_CACHE: "/settings/cache",
  RECURRING_TRANSACTIONS: (account?: string) => `/recurring/${account || ""}`,
  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_RECURRING_TODAY: "/notifications/recurring/today",
  NOTIFICATIONS_RECURRING_OVERDUE: "/notifications/recurring/overdue",
  NOTIFICATIONS_RECURRING_UPCOMING: "/notifications/recurring/upcoming",
  NOTIFICATIONS_PENDING_INCOME: "/notifications/pending/income",
  NOTIFICATIONS_PENDING_EXPENSES: "/notifications/pending/expenses",
  NOTIFICATIONS_CONTACT_INVITES: "/notifications/invites",
  NOTIFICATIONS_RECEIVED_TRANSACTIONS: "/notifications/received",
  SETTINGS_VOICE_ASSISTANTS: "/settings/voice-assistants",
  SETTINGS_APPEARANCE: "/settings/colors",
  SETTINGS_CONTACTS: "/settings/contacts",
  SETTINGS_HELP: "/settings/help",
  SETTINGS: "/settings",
  SETTINGS_EXTENSIONS: "/settings/extensions",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_ACCOUNTS: "/settings/accounts",
  SETTINGS_ACCOUNTS_NEW: "/settings/accounts/new",
  SETTINGS_PAYMENT_METHODS: "/settings/payment-methods",
  SETTINGS_ACCOUNTS_DETAIL: (accountId: string) =>
    `/settings/accounts/${accountId}`,
  LOGOUT: "/logout",
  REGISTER: "/register",
  PASSWORD_RECOVERY: "/password-recovery",
  NOT_FOUND: "/404",
  SETTINGS_CATEGORIES: "/settings/categories",
  SETTINGS_CATEGORIES_DETAIL: (categoryId: string) =>
    `/settings/categories/${categoryId}`,
  SETTINGS_SOURCES: "/settings/sources",
  SETTINGS_SOURCES_DETAIL: (sourceId: string) =>
    `/settings/sources/${sourceId}`,
  FILES: (accountId?: string) => `/files/${accountId || ""}`,
  DASHBOARD: (account?: any) => {
    if (account) {
      return `/dashboard/${account}`;
    }

    return "/dashboard/";
  },
  LOANS: (account?: any) => {
    if (account) {
      return `/loans/${account}`;
    }

    return "/loans/";
  },
  LOAN_DETAIL: (account: any, loan?: string) => {
    if (account) {
      if (loan) {
        return `/loan/${account}/${loan || ""}`;
      }
      return `/loan/${account}`;
    }

    return "/loan/";
  },
  AUTO_HOME: "/auto",
};
